import { AddpaymentsComponent } from './addpayments/addpayments.component';
import { ViewpaymenthistoryComponent } from './viewpaymenthistory/viewpaymenthistory.component';

export const PaymentHistoryRouting = [
   {path: 'add-payment', component: AddpaymentsComponent},
   {path: 'view-payment', component:  ViewpaymenthistoryComponent}
];
